import styled from 'styled-components';

export const AchievementCongratulationsPageStyled = styled.div<{isDesktop: boolean}>`
    max-width: ${({ isDesktop }) => isDesktop ? '293px' : 'auto'};
`;
